import { Action, initialState, State } from "store/store";

export const updateUserPalette = (
  state: State = initialState,
  { data }: Action
): State => {
  const nextState = {
    ...state,
    theme: {
      ...(state as any).theme,
      userPalette: data,
    },
  };

  return nextState;
};